import React, {useEffect, useState} from 'react';
import classNamesBind from "classnames/bind";
import styles from './CsFaqList.module.scss';
import {CsLayout} from "../../layout/CsLayout";
import {useSelector} from "react-redux";
import {I18nState} from "../../../../redux/I18n";
import {gql, useQuery} from "@apollo/client";
import {Query} from "../../../../graphql/types";
import {ApolloCatch} from "../../../../utils/apollo/apolloCatch";
import {navigate} from "hookrouter";
import {Element} from "react-scroll";
import {BizTitle} from "../../../shares/bizTitle/BizTitle";
import {Pipe} from "../../../../utils/pipe/pipe";
import moment from "moment";
import {Pager} from "../../../shares/pager/Pager";
import {useTranslation} from "react-i18next";
import {I18nKeys} from "../../../../i18n/i18nKeys";

const cx = classNamesBind.bind(styles);

export const CsFaqList = (props: {
    page: number
}) => {
    const langCode = useSelector<any, I18nState>(state => state.i18n).langCode;

    let [listStartNumber, setListStartNumber] = useState<number>(0);
    const {data, refetch} = useQuery<Query, any>(gqlData, {
        variables: {
            page: props.page
        }
    });
    const [t] = useTranslation('common');

    useEffect(() => {
        if (!refetch) {
            return;
        }

        refetch({
            page: 0
        }).catch(ApolloCatch({}));

        if(data?.faqList) {
            const getListStartNumber = () => {
                let total = data.faqList.total;
                let page = data.faqList.page;
                let size = data.faqList.size;
                return total - (page * size);
            }

            setListStartNumber(getListStartNumber());        
        }
    }, [langCode, data, refetch, setListStartNumber]);


    const handler = {
        onClickNotice: (id: number) => {
            navigate(`/cs/faq/view/${id}`);
        },
        onChangePage: (p: number) => {
            navigate(`/cs/faq/list/${p}`)
        }
    };

    
    return (
        <CsLayout activatedSuffixRouter={'/faq/list'}>
            {data &&
            <>
                <Element name='pager'/>
                <BizTitle>{t("cs.faqTitle")}</BizTitle>

                <div className={cx('table')}>
                    <div className={cx('col-header', 'col-id')}>{t(I18nKeys.cs.idx.key)}</div>
                    <div className={cx('col-header', 'col-title')}>{t("cs.title")}</div>
                    <div className={cx('col-header', 'col-view')}>{t("cs.viewCount")}</div>
                    <div className={cx('col-header', 'col-created-at')}>{t("cs.createDate")}</div>
                    <div className={cx('col-header', 'col-updated-at')}>{t("cs.updateDate")}</div>
                </div>

                {data.faqList.list.map((value, index) => (
                    <div key={index} className={cx('table', 'hover', 'pointer')}
                         onClick={() => handler.onClickNotice(value.id)}>
                        <div className={cx('col', 'col-id')}>{listStartNumber--}</div>
                        <div className={cx('col', 'col-title', 'ellipsis')}>{value.title}</div>
                        <div className={cx('col', 'col-view')}>{Pipe.toSeparatorNumber(value.views)}</div>
                        <div className={cx('col', 'col-created-at')}>{moment(value.createdAt).format('YY.MM.DD')}</div>
                        <div className={cx('col', 'col-updated-at')}>{moment(value.updatedAt).format('YY.MM.DD')}</div>
                    </div>

                ))}

                <Pager
                    offset={-100}
                    page={data.faqList.page}
                    size={data.faqList.size}
                    total={data.faqList.total}
                    onChange={handler.onChangePage}/>
            </>
            }
        </CsLayout>
    )
}

const gqlData = gql`
    query DATA($page: Int!) {
        faqList(page: $page, size: 20) {
            page
            size
            total
            list {
                id
                title
                views
                createdAt
                updatedAt
            }
        }
    }
`;
